import React, { Component } from 'react';
import { browserHistory } from 'react-router';
import Moment from 'moment';
import { INTERNAL_STATUSES } from '../constants/bookingConstants';
import { UI_STATES } from '../../core/constants/coreConstants';
import { getApiEndPoint, isLocal, isDev } from '../../configurations';

class BookingStatus extends Component {

    constructor(props) {
        super(props);
    }

    onRebook() {
        let { jobId } = this.props.routeParams;

        if (isLocal() || isDev())
            browserHistory.push('/booking/'.concat(jobId).concat('/').concat(INTERNAL_STATUSES.REBOOK));
        else
            browserHistory.push('/contactus/rebook/'.concat(jobId));

    }

    onContactUs() {
        let { jobId } = this.props.routeParams;
        browserHistory.push('/contactus/incorrectdetails/'.concat(jobId));
    }

    formatTime(startTime, endTime) {
        let startTimeString = Moment(startTime).format("h a");
        let endTimeString = Moment(endTime).format("h a");

        if (startTime)
            return "Between ".concat(startTimeString).concat(" and ").concat(endTimeString).concat(" (Local Time)");
        else
            return "Before ".concat(endTimeString).concat(" (Local Time)");
    }
    
    addToCalendar() {
        let { booking } = this.props;
        let apiEndpoint = getApiEndPoint();

        let downloadUrl = apiEndpoint.concat("/booking/calendar/").concat(booking.details.jobId)
        window.location.href = downloadUrl;
    }

    render() {
        let { booking: { details }, status, uiState } = this.props;
        let displayDate = Moment(details.bookForDateTime).format("dddd, Do MMMM");
        let displayTime = this.formatTime(details.bookForStartTime, details.bookForEndTime);
        let bookedStyle = status.booked ? 'progress-2 active current' : 'progress-2 active';
        let isInstalled = status.completed;
        let installedStyle = isInstalled ? 'progress-3 active current' : 'progress-3';
        let isReturning = uiState !== UI_STATES.BOOKING_COMPLETED;
        let isrefpfsDepot = details.isrefpfsDepot;
        let isDesptached = status.inTransit;
        let type = details.isProjectUpgrade ? "Upgraded" : "Installed";
        let typeAlt = details.isProjectUpgrade ? "upgrade" : "installation";

        return (
            <div>
                {isReturning ? (
                    <div className="row">
                        <div className="col-xs-12">
                            <div className="progress-indicator progress-indicator-three">
                                <em className="progress-line" />
                                <a href="#" className="active">
                                    <i className="fa fa-hourglass" />
                                    <em>Pending</em>
                                </a>
                                <a href="#" className={bookedStyle}>
                                    <i className="fa fa-check-square" />
                                    <em>Booked</em>
                                </a>
                                <a href="#" className={installedStyle}>
                                    <i className={"fa " + (isrefpfsDepot ? "fa-map-marker" : "fa-wrench")} />
                                    <em>{isrefpfsDepot ? "Delivered" : type}</em>
                                </a>
                            </div>
                        </div>
                    </div>
                ) : null}
                <div className="jumbotron text-center confirmation">
                    {!isReturning ? (
                        <div>
                            <h1>Booked!</h1>
                            <p><i className="fa fa-check fa-4x" /></p>
                        </div>
                    ) : (!isrefpfsDepot || isInstalled ? (
                        <p>Your EFTPOS Terminal {isInstalled ? (isrefpfsDepot ? "has been delivered!" : "has been " + type.toLowerCase() + "!") : "is scheduled to be " + type.toLowerCase() + " on:"}</p>
                    ) : null)}

                    {isrefpfsDepot && !isInstalled && !isDesptached ? (
                        <div className="card text-center p-20">
                            <p><i className="fa fa-truck fa-4x fa-flip-horizontal" /></p>
                            Your EFTPOS Terminal has been scheduled for delivery, an {typeAlt} kit will be dispatched next business day.
                        </div>
                    ) : null}

                    {!isInstalled & !isrefpfsDepot ? (
                        <div>
                            <div className="card-slim card-slim-margin text-center">
                                <strong>{displayDate}</strong>
                                <br />
                                <span>{displayTime}</span>
                                <div className="well client-requires-id">
                                    Please ensure <b>{details.contact}</b> is present with a valid photo ID (eg. drivers licence).
                                </div>
                                <div className="well client-required-onsite">
                                    Please ensure <b>{details.contact}</b> is present to complete the {typeAlt}.
                                </div>
                            </div>
                            <p>A technician will call you to confirm the time before coming out.</p>
                            <button onClick={this.addToCalendar.bind(this)} className="btn btn-client btn-lg btn-block">
                                <i className="fa fa-calendar" /> Add to Calendar
                            </button>
                        </div>
                    ) : null}

                    {isrefpfsDepot && isDesptached ? (
                        <div>
                            <div className="card text-center p-20">
                                <p><i className="fa fa-truck fa-4x fa-flip-horizontal" /></p>
                                Your EFTPOS terminal and {typeAlt} kit is on its way!
                            </div>
                        </div>
                    ) : null}

                    {!isReturning ? (
                        <p className="sub-text">You may now close the window.</p>
                    ) : (
                        <div className="m-t-20">
                            <h3 className="client-text">Need assistance?</h3>
                            <div className="row">
                                {!isInstalled && !isDesptached ? (
                                    <div className="col-xs-6">
                                        <button type="button" className="btn btn-client btn-lg btn-block" onClick={this.onRebook.bind(this)}>Rebook</button>
                                    </div>
                                ) : null}
                                <div className={isInstalled || isDesptached ? "col-xs-12" : "col-xs-6"}>
                                    <button type="button" className="btn btn-client-alt btn-lg btn-block" onClick={this.onContactUs.bind(this)}>Contact Us</button>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        );
    }
}

export default BookingStatus;


// WEBPACK FOOTER //
// ./app/booking/components/bookingStatus.js